const Data_phonenumber = {
  
    Phone_number: [
      { id: 1, name: "คณบดี", phone: "48001", room: "A201" },
      { id: 2, name: "รองคณบดีฝ่ายบริหารและทรัพยากรบุคคล", phone: "48003", room: "A203" },
      { id: 3, name: "รองคณบดีฝ่ายวิจัย นวัตกรรม และวิเทศสัมพันธ์", phone: "48004", room: "A204" },
      { id: 4, name: "รองคณบดีฝ่ายการศึกษา", phone: "48005", room: "A208" },
      { id: 5, name: "รองคณบดีฝ่ายมาตรฐานและคุณภาพห้องปภิบัติการ", phone: "48030", room: "อาคารชันสูตร" },
      { id: 6, name: "รองคณบดีฝ่ายศูนย์ความเป็นเลิศทางคลินิกและการศึกษาหลังปริญญา", phone: "48114", room: "B201" },

      { id: 8, name: "ผู้ช่วยคณบดีฝ่ายบริการวิชาการ และการศึกษาตลอดชีวิต", phone: "48027", room: "B203" },
      { id: 9, name: "ผู้ช่วยคณบดีฝ่ายศิษย์เก่าและนักศึกษาสัมพันธ์", phone: "48040", room: "B203" },
      { id: 10, name: "ผู้ช่วยคณบดีฝ่ายประชาสัมพันธ์และภาพลักษณ์ขององค์กร", phone: "48029", room: "B204" },

      { id: 12, name: "ผู้ช่วยคณบดีฝ่ายมาตรฐานและคุณภาพสถานศึกษา", phone: "48115", room: "A211" },
      { id: 13, name: "ผู้ช่วยคณบดีฝ่ายกายภาพฯ", phone: "48082", room: "B201-1" },
      { id: 14, name: "เลขานุการคณะฯ", phone: "48012", room: "A210" },
      { id: 15, name: "งานบริหารทั่วไป (โบว์ เอม เจมส์)", phone: "48002", room: "A202" },
      { id: 16, name: "หน่วยทรัพยากรบุคคล (พัช แน็ก ต้นข้าว กระแต)", phone: "48006", room: "A202" },
      { id: 17, name: "ห้องประชุมคณะฯ", phone: "48011", room: "A301" },
      { id: 18, name: "หน่วยคอมพิวเตอร์และศูนย์สารสนเทศ (เล็ก)", phone: "48018", room: "E203" },
      { id: 19, name: "หน่วยเทคโนโลยีสารสนเทศ (น้ำ เทอด)", phone: "48045", room: "E203" },
      { id: 20, name: "หน่วยอาคารสถานที่และยานพาหนะ (พี ป๋อง พขร เต้ย)", phone: "48050", room: "B103" },
      { id: 21, name: "งานคลัง (บี ติ๊ก)", phone: "48008", room: "ห้องคลัง" },
      { id: 22, name: "งานคลัง (เชอรี่ บิ๊ว เล็ก)", phone: "48068", room: "ห้องคลัง" },
      { id: 23, name: "งานคลัง (เฟรม เจนนี่) ", phone: "48069", room: "ห้องคลัง" },
      { id: 24, name: "หน่วยพัสดุ (จุ๋มจิ๋ม โบว์)", phone: "48067", room: "A104" },
      { id: 25, name: "หน่วยพัสดุ (นัท)", phone: "48007", room: "A104" },
      { id: 26, name: "หน่วยพัสดุ (โอ๋ แนน นุ้ย)", phone: "48035", room: "A104" },
      { id: 27, name: "หน่วยแผนงานและงบประมาณ (ปุ๊กกี้ น้อยหน่า)", phone: "48010", room: "B206" },
      { id: 28, name: "หน่วยประกันคุณภาพการศึกษา (แอน รวง)", phone: "48049", room: "B206" },
      { id: 29, name: "หน่วยรับฟังเสียงลูกค้า (บัว เม)", phone: "48049", room: "B206" },
      { id: 30, name: "หน่วยประชาสัมพันธ์ (ฝ้าย ปลาย อาย เค)", phone: "48028", room: "B204" },
      { id: 31, name: "การศึกษา (อ้อมเล็ก ขวัญ วิม ชอปเปอร์)", phone: "48009", room: "A108" },
      { id: 32, name: "หน่วยบัณฑิตศึกษา (น้อย)", phone: "48060", room: "A108" },
      { id: 33, name: "หน่วยกิจการการศึกษา (อ้อมใหญ่)", phone: "48053", room: "A108" },
      { id: 34, name: "สโมสรนักศึกษา", phone: "48063", room: "-" },
      { id: 35, name: "ห้องสมุด (วาว แอร์ ปอ)", phone: "48025", room: "J301" },
      { id: 36, name: "หน่วยสนับสนุนงานวิจัย (ต้อม แอมม่า)", phone: "48070", room: "A103" },
      { id: 37, name: "งานบริการวิชาการ (ก้อยเล็ก จ๋า นุกนิก)", phone: "48071", room: "A110" },
      { id: 38, name: "หน่วยวิเทศสัมพันธ์ (ไก่แกง แบงค์)", phone: "48026", room: "A103" },
      { id: 39, name: "ห้องผู้เชี่ยวชาญต่างประเทศ", phone: "48113", room: "A304" },
      { id: 40, name: "หัวหน้าสำนักวิชาสัตวแพทยศาสตร์", phone: "48086", room: "D204" },
      { id: 41, name: "เลขาสำนักวิชาสัตวแพทยศาสตร์ (แป๋ว)", phone: "48015", room: "D203" },
      { id: 42, name: "เลขาสำนักวิชาสัตวแพทยศาสตร์ (แป๋ว)", phone: "48055", room: "D203" },
      { id: 43, name: "เลขาสำนักวิชาสัตวแพทยศาสตร์ (ฟ้า)", phone: "48023", room: "D203" },
      { id: 44, name: "เลขาสำนักวิชาสัตวแพทยศาสตร์ (หนึ่ง)", phone: "48046", room: "D203" },
      { id: 45, name: "ห้องพักอาจารย์", phone: "48066", room: "F307" },
      { id: 46, name: "ห้องพักอาจารย์", phone: "48057", room: "D306" },
      { id: 47, name: "ห้องพักอาจารย์ (ชั้นล่าง)", phone: "48083", room: "F307" },
      { id: 48, name: "ห้องพักอาจารย์ (ชั้นบน)", phone: "48084", room: "F307" },
      { id: 49, name: "ห้องพักอาจารย์", phone: "48105", room: "E207" },
      
      { id: 52, name: "รองคณบดีฝ่ายฝ่ายมาตรฐานและคุณภาพห้องปฏิบัติการ", phone: "48030", room: "อาคารชันสูตร" },
      { id: 53, name: "เลขานุการศูนย์เวชศาสตร์ชันสูตร (จอย พลอย กิ๊บ)", phone: "48041", room: "N" },
      { id: 54, name: "รองผู้อำนวยการศูนย์เวชศาสตร์ชันสูตร", phone: "48042", room: "N" },
      { id: 55, name: "ห้องปฏิบัติการP2+", phone: "48059", room: "N" },
      { id: 56, name: "ห้องปฏิบัติการฮอร์โมน", phone: "48054", room: "E401" },
      { id: 57, name: "ห้องปฏิบัติการตรวจเคมีอาหารและน้ำนม", phone: "48056", room: "F405" },
      { id: 58, name: "ห้องปฏิบัติการสัตว์น้ำ", phone: "48061", room: "F109" },
      { id: 59, name: "ห้องปฏิบัติการกลาง", phone: "48085", room: "E301" },
      { id: 60, name: "ห้องปฏิบัติการกายวิภาค", phone: "48014", room: "D104" },
      { id: 61, name: "ห้องปฏิบัติการทางเคมีอาหาร", phone: "48016", room: "D405" },
      { id: 62, name: "ห้องปฏิบัติการชันสูตรซากสัตว์", phone: "48017", room: "E101" },
      { id: 63, name: "ห้องพักนักวิทยาศาสตร์", phone: "48019", room: "F305" },
      { id: 64, name: "ห้องปฏิบัติการกล้องจุลทรรศ์", phone: "48020", room: "E211" },
      { id: 65, name: "ห้องปฏิบัติการตรวจคุณภาพอาหาร", phone: "48021", room: "D405" },
      { id: 66, name: "ห้องปฏิบัติการวิจัยโรคกระดูกและข้อ", phone: "48022", room: "D403" },
      { id: 67, name: "ห้องปฏิบัติการกลางชั้น 4 (E406,E410)", phone: "48039", room: "E" },
      { id: 68, name: "ห้องปฏิบัติการสูติศาสตร์", phone: "48064", room: "F103" },
      { id: 69, name: "ห้องพักคนงานสัตว์ทดลอง", phone: "48051", room: "C106" },
      { id: 70, name: "ศูนย์สุขภาพช้างและสัตว์ป่า", phone: "48097", room: "E208" },
     
      { id: 72, name: "มูลนิธิช้างสู่ธรรมชาติ", phone: "48047", room: "D206" },
      { id: 73, name: "มูลนิธิช้างสู่ธรรมชาติ (Fax)", phone: "48048", room: "D206" },
      { id: 74, name: "ห้องวารสาร", phone: "48076", room: "J202" },
      { id: 75, name: "โรงอาหาร", phone: "48044", room: "K" },
     
      { id: 77, name: "ผู้อำนวยการศูนย์สัตวแพทย์สาธารณสุขและอาหารปลอดภัย", phone: "48083#109", room: "D203" },
      
    { id: 79, name: "ศูนย์สัตวแพทย์สาธารณสุขและอาหารปลอดภัยเอเชียแปซิฟิก", phone: "48073", room: "F408" },
    { id: 80, name: "ศูนย์สัตวแพทย์สาธารณสุขและอาหารปลอดภัยเอเชียแปซิฟิก", phone: "48074", room: "F408" },
    { id: 81, name: "ผู้อำนวยการ รพ.สัตว์ใหญ่", phone: "48037", room: "M" },
    { id: 82, name: "โรงพยาบาลสัตว์ใหญ่", phone: "48038", room: "M" },
    { id: 83, name: "ผู้อำนวยการฝ่าย รพ.สัตว์เล็ก", phone: "48096", room: "รพ.สล." },
    { id: 84, name: "ห้องเลขา รพ.สัตว์เล็ก", phone: "48078", room: "รพ.สล." },
    { id: 85, name: "ห้องเวชระเบียน รพ.สัตว์เล็ก", phone: "48112", room: "รพ.สล." },
    { id: 86, name: "ห้องเวชระเบียน รพ.สัตว์เล็ก", phone: "48031", room: "รพ.สล." },
    { id: 87, name: "ห้องการเงิน รพ.สัตว์เล็ก", phone: "48077", room: "รพ.สล." },
    { id: 88, name: "ห้องศัลยกรรม รพ.สัตว์เล็ก", phone: "48036", room: "รพ.สล." },
    { id: 89, name: "ห้องตรวจฉุกเฉิน", phone: "48032", room: "รพ.สล." },
    { id: 90, name: "ห้องตรวจ 12 รพ.สัตว์เล็ก", phone: "48101", room: "รพ.สล." },
    { id: 91, name: "ห้องแมวติดเชื้อ รพ.สัตว์เล็ก", phone: "48102", room: "รพ.สล." },
    { id: 92, name: "ห้องตรวจอัลตร้าซาวด์ รพ.สัตว์เล็ก", phone: "48110", room: "รพ.สล." },
    { id: 93, name: "ร้านกาแฟ รพ.สัตว์เล็ก", phone: "48111", room: "รพ.สล." },
    { id: 94, name: "ห้องตรวจ 3 รพ.สัตว์เล็ก", phone: "48108", room: "รพ.สล." },
    { id: 95, name: "ห้องตรวจ 4 รพ.สัตว์เล็ก", phone: "48109", room: "รพ.สล." },
    { id: 96, name: "ห้องตรวจ 5 รพ.สัตว์เล็ก", phone: "48087", room: "รพ.สล." },
    { id: 97, name: "ห้องตรวจ 6 รพ.สัตว์เล็ก", phone: "48088", room: "รพ.สล." },
    { id: 98, name: "ห้องตรวจ 7 รพ.สัตว์เล็ก", phone: "48089", room: "รพ.สล." },
    { id: 99, name: "ห้องช่าง รพ.สัตว์เล็ก", phone: "48090", room: "รพ.สล." },
    { id: 100, name: "ห้องตรวจ 8 รพ.สัตว์เล็ก", phone: "48091", room: "รพ.สล." },
    { id: 101, name: "ห้องตรวจ 9 รพ.สัตว์เล็ก", phone: "48092", room: "รพ.สล." },
    { id: 102, name: "ห้องตรวจ 10 รพ.สัตว์เล็ก", phone: "48034", room: "รพ.สล." },
    { id: 103, name: "Ward รพ.สัตว์เล็ก", phone: "48079", room: "รพ.สล." },
    { id: 104, name: "Lab รพ.สัตว์เล็ก", phone: "48080", room: "รพ.สล." },
    { id: 105, name: "ห้องพักสัตวแพทย์ รพ.สัตว์เล็ก", phone: "48095", room: "รพ.สล." },
    { id: 106, name: "ห้อง X-ray รพ.สัตว์เล็ก", phone: "48081", room: "รพ.สล." },
    { id: 107, name: "ห้องยา รพ.สัตว์เล็ก", phone: "48093", room: "รพ.สล." },
    { id: 108, name: "ห้องวัคซีน รพ.สัตว์เล็ก", phone: "48094", room: "รพ.สล." },
    { id: 109, name: "ห้องสต็อกยา รพ.สัตว์เล็ก", phone: "48033", room: "รพ.สล." },
    { id: 110, name: "PODD1", phone: "48075", room: "F408" },
    { id: 111, name: "ผู้อำนวยการศูนย์ PODD", phone: "48058", room: "F404" },
    { id: 112, name: "Pet wellness center", phone: "48043", room: "PWC" },
    { id: 113, name: "ผู้อำนวยการ รพ.สัตว์แม่ออน", phone: "053-037-071", room: "แม่ออน" },
    { id: 114, name: "Pet CMU", phone: "082-273-3224", room: "Pet CMU" }
     
  ],

  }

export default Data_phonenumber;
